// @flow

import * as types from '../actionTypes';
import { createActionBundleForSingleton } from '../utils';

export const getUserActions = createActionBundleForSingleton(
  types.GET_USER_ASYNC,
);
